import React, { useState } from 'react';
import DataGridToolbar from 'components/datagrid/DataGridToolbar';

/**
 * Placeholder, bulk actions to-be-added later
 */
const CompletedBookingsTableToolbar = () => {
	const [activeModal, _setActiveModal] = useState<{
		id: 'delete';
		rowIds: string[];
	} | null>(null);

	const activeModalId = activeModal?.id;
	//const activeModalRowIds = activeModal?.rowIds ?? [];

	const renderActiveDialog = () => {
		switch (activeModalId) {
			case 'delete':
				return null;
			default:
				return null;
		}
	};

	return (
		<>
			<DataGridToolbar
				persistKey="CompletedBookingsTable"
				exportFileName="rentle-bookings"
				selectedRowsActions={{
					deleteAction: {
						enabled: false,
						handler: () => {},
					},
					exportAction: {
						enabled: true,
					},
				}}
			/>
			{renderActiveDialog()}
		</>
	);
};

export default CompletedBookingsTableToolbar;
